export const isSingleActionWorkflowActiveSelector = state => state.singleActionsReducer.isActive;
export const singleActionTypeSelector = state => state.singleActionsReducer.singleActionType;
export const singleActionStepSelector = state => state.singleActionsReducer.singleActionStep;
export const commentSelector = state => state.singleActionsReducer.comment;
export const shouldShowVerificationMessageSelector = state => state.singleActionsReducer.shouldShowVerificationMessage;
export const profileUpdateSelector = state => state.singleActionsReducer.profileUpdate;
export const userIdSelector = state => state.singleActionsReducer.userId;
export const errorSelector = state => state.singleActionsReducer.error;



// WEBPACK FOOTER //
// ./src/js/redux/selectors/singleActionsSelector.js